import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, takeUntil } from 'rxjs/operators';

@Directive({ selector: '[appIsAtBottom]' })
export class IsAtBottomDirective implements OnInit, OnDestroy {
    // Output, który będzie emitował stan 'isAtBottom'
    @Output() isAtBottom = new EventEmitter<boolean>();

    // Input do ustawienia tolerancji (domyślnie 1 piksel)
    @Input() bottomTolerance: number = 1;

    // Input do ustawienia opóźnienia debounce (domyślnie 50ms)
    @Input() scrollDebounceTime: number = 50;

    private destroy$ = new Subject<void>();
    private lastIsAtBottomState: boolean | null = null; // Przechowuje ostatni wyemitowany stan

    constructor(private el: ElementRef<HTMLElement>) { }

    ngOnInit(): void {
        // Nasłuchiwanie zdarzenia 'scroll' na elemencie hosta
        fromEvent(this.el.nativeElement, 'scroll')
            .pipe(
                debounceTime(this.scrollDebounceTime), // Ogranicz częstotliwość wywołań
                map(() => this.checkIsAtBottom()), // Mapuj zdarzenie na stan boolean
                distinctUntilChanged(), // Emituj tylko, gdy stan się zmieni
                takeUntil(this.destroy$) // Automatycznie zamykaj subskrypcję
            )
            .subscribe((atBottom: boolean) => {
                // Emituj nowy stan tylko, jeśli różni się od poprzedniego
                if (this.lastIsAtBottomState !== atBottom) {
                    this.isAtBottom.emit(atBottom);
                    this.lastIsAtBottomState = atBottom;
                }
            });

        // Sprawdź stan początkowy po inicjalizacji
        setTimeout(() => {
            const initialIsAtBottom = this.checkIsAtBottom();
            this.isAtBottom.emit(initialIsAtBottom);
            this.lastIsAtBottomState = initialIsAtBottom;
        }, 0); // Użyj setTimeout, aby upewnić się, że DOM jest już wyrenderowany
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    /**
     * Metoda do obliczania stanu 'isAtBottom'.
     */
    private checkIsAtBottom(): boolean {
        const element = this.el.nativeElement;
        // Sprawdzamy, czy element jest przewinięty na sam dół z uwzględnieniem tolerancji.
        return (element.scrollTop + element.clientHeight) >= (element.scrollHeight - this.bottomTolerance);
    }

}
